import { ComponentProps, ComponentType } from 'react';
import dynamic from 'next/dynamic';

interface INoSSRProps {
  children: any;
}

type TReturnType = ComponentType<INoSSRProps>;

const NoSSR = dynamic(
  (): Promise<TReturnType> =>
    Promise.resolve((({ children }) => children) as TReturnType),
  { ssr: false }
);

export const withNoSSR = <P extends {}>(Component: ComponentType<P>) => {
  const NoSSRComponent = (props: ComponentProps<typeof Component>) => (
    <NoSSR>
      <Component {...props} />
    </NoSSR>
  );

  NoSSRComponent.displayName = Component.displayName;

  return NoSSRComponent;
};

export default NoSSR;
